export default __webpack_public_path__ + "882a2b578538a7508149c81ed9a17893.svg";